import { gql } from '@apollo/client';

export const GET_CABLE_SNAPS = gql`
    query getCableSnaps($query: String!) {
        searchV2(query: $query) {
            total
            currentPage
            pageCount
            results {
                sku
                productName
                image
                salesUnit
                quantityUnit
                ean
                cableSnaps {
                    chargeNr
                    length
                }
            }
        }
    }
`;
